import { Box, Typography } from "@mui/material";
import { Sparkles } from "lucide-react";
import { useTranslationApp } from "../../../../lib/i18next";
import {
  MODAL_IMAGE_EDIT_EMPTY_STATE_TITLE,
  MODAL_IMAGE_EDIT_EMPTY_STATE_DESCRIPTION,
} from "../../../../i18n/keysTranslations";

/**
 * Componente que muestra el estado vacío del chat
 */
const EmptyState = () => {
  const { t } = useTranslationApp();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Box sx={{ textAlign: "center", maxWidth: 320 }}>
        <Box sx={{ display: "flex", justifyContent: "center", mb: 1.5 }}>
          <Box
            sx={{
              width: 48,
              height: 48,
              bgcolor: "#000",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Sparkles size={24} color="#fff" />
          </Box>
        </Box>
        <Typography
          variant="h6"
          sx={{ fontWeight: 600, color: "#000", mb: 0.5, textAlign: "center" }}
        >
          {t(MODAL_IMAGE_EDIT_EMPTY_STATE_TITLE)}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t(MODAL_IMAGE_EDIT_EMPTY_STATE_DESCRIPTION)}
        </Typography>
      </Box>
    </Box>
  );
};

export default EmptyState;
